import { render } from "./bot-protected-submit-button.vue?vue&type=template&id=7203e85e"
import script from "./bot-protected-submit-button.vue?vue&type=script&lang=js"
export * from "./bot-protected-submit-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__